<div class="main-container">
  <div>
    @for (entry of aggs | keyvalue; track entry) {
      <span class="entry-container">
        <span class="entry-info">{{ entry.key }}</span>
        <b>{{ entry.value }}</b>
      </span>
    }
  </div>
</div>
